import { render } from "./shopCategoryProducts.vue?vue&type=template&id=35a372b2&scoped=true"
import script from "./shopCategoryProducts.vue?vue&type=script&lang=js"
export * from "./shopCategoryProducts.vue?vue&type=script&lang=js"

import "./shopCategoryProducts.vue?vue&type=style&index=0&id=35a372b2&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a372b2"]])

export default __exports__